/**
 * @deprecated use ProductContext from @shopgate/engage/product
 */
export { ProductContext } from '@shopgate/engage/product';
